import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import AlmigProgressBar from "../grundelemente/AlmigProgressBar";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoPanel from "../grundelemente/InfoPanel";
import UnitValueContainer from "../einheiten/UnitValueContainer";
import UnitTextContainer from "../einheiten/UnitTextContainer";
import { compressorDisplayedStateTNR } from "../model/Kompressor";

const KompressorInfoPanel = props => (
	<InfoPanel>
		<InfoBlock>
			<FormattedMessage id="Actual system pressure" /><br />
			<UnitValueContainer unit="pressure" value={props.compressor.line_pressure_bar} />
			<span>{" "}</span><UnitTextContainer unit="pressure" />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="Temperature" /><br />
			<UnitValueContainer unit="temperature" value={props.compressor.temperature_degC} />
			<span>{" "}</span><UnitTextContainer unit="temperature" />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="State" /><br />
			<FormattedMessage id={ compressorDisplayedStateTNR(props.compressor) } />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="Delivery volume" /><br />
			<UnitValueContainer unit="volume_over_minutes" value={props.compressor.delivery_volume_m3min} />
			<span>{" "}</span><UnitTextContainer unit="volume_over_minutes" />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="Energy consumption" /><br />
			<UnitValueContainer unit="power" value={props.compressor.electrical_power_kW} />
			<span>{" "}</span><UnitTextContainer unit="power" />
		</InfoBlock>
		<InfoBlock>
			<FormattedMessage id="Load factor" /><br />
			<AlmigProgressBar value={props.compressor.load_factor_percent} />
		</InfoBlock>
		<InfoDateContainer />
	</InfoPanel>
);

KompressorInfoPanel.propTypes = {
	compressor: PropTypes.object.isRequired
};

export default KompressorInfoPanel;
